const type = 'SET_CAMERAS_FILTER'
const set = cameras => ({ type, cameras })
const reducer = (state = [], action) => action.type === type ? setCameras(action.cameras) : state

const setCameras = cameras => cameras

const camerasFilterState = { set: set, reducer: reducer }
export default camerasFilterState
